module.exports = __webpack_public_path__ + "img/cover.00bd2e63.png";